import React from 'react';
import { LoginLogo } from 'shared/components/ui/login-logo';

import * as Styled from './auth-page-layout.style';

export type AuthPageLayoutProps = {
  children: React.ReactNode;
};

// The full-page shell of the pages an emailed account link opens: centred, narrow, the logo on top.
export const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({ children }) => (
  <Styled.Container>
    <Styled.Body>
      <Styled.BodyContent>
        <LoginLogo />
        {children}
      </Styled.BodyContent>
    </Styled.Body>
  </Styled.Container>
);
